import React, {useState, useEffect} from 'react'
import './style.css'
import {Container, Row, Col} from 'react-bootstrap'
import CompKategori from './dashcomp/comp_kategori'
import {Link, useHistory} from 'react-router-dom'
import { API_URL } from 'api'
import { access_token } from 'token'
import axios from 'axios'

export default function Kategoris() {
    const history = useHistory()
    const handleClick = () => {
        history.push('/category')
    }

    const [datas, setData] = useState([])
    const [requesError, setRequesError] = useState()

    const data = [...datas]
    console.log(data)


    async function getData(){
        try{
            const response = await axios.get(`${API_URL}/api/reseller/homepage/category`)
            setData(response.data.data)
        } catch (err) {
            setRequesError(err.message)
        }
    }

    useEffect(() => {
        getData()
    }, [])

    axios.interceptors.request.use(
        config => {
            config.headers.authorization = `bearer ${access_token}`;
            return config
        },
        error => {
            return Promise.reject(error)
        }
    )

    return (
        <Container>
        <div className="dashboard-kategori">
            <h3>Kategori <Link to="/category">Lihat Selengkapnya</Link></h3>
            <Row>
            {
                Kategori.map((data, i) => {
                    return (
                         <Col md={2}>
                            <div key={i} onClick={handleClick} className="kategori-cards">
                            <img src={data.src} alt="kategori" />
                                <div className="kategori-teks">
                                    <p>{data.text}</p> 
                                </div>
                            </div>
                         </Col>                           
                    )
                })
            }
            {requesError && <p>{requesError}</p>}
            </Row>
        </div>
            <CompKategori />
       </Container>
    )
}

const Kategori = [
    {src:"asset/dashboard/kategori/kategori1.png", text:"Al-Qur’an"},
    {src:"asset/dashboard/kategori/kategori1.png", text:"Buku Cetak K13"},
    {src:"asset/dashboard/kategori/kategori1.png", text:"Kurma"},
    {src:"asset/dashboard/kategori/kategori1.png", text:"Buku Islami"}
]
